import { Checkbox } from 'antd';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { CheckboxGroupContainer } from '../../incidentForm/fields/customCheckbox/style';

const CheckboxGroupComponent = ({ field, value, onChange, disabledField }) => {
  const { options, defaultValue } = useMemo(() => {
    const checkboxOptions = [];
    const defaultValues = [];
    for (const item of field.list) {
      if (value?.[item.idInput]) defaultValues.push(item.idInput);
      checkboxOptions.push({
        value: item.idInput,
        label: item.label,
      });
    }

    return {
      options: checkboxOptions,
      defaultValue: defaultValues,
    };
  }, [value]);

  const onChangeValue = (checkedValues) => {
    const checkboxValue = {};
    field.list.forEach((item) => {
      checkboxValue[item.idInput] = checkedValues.includes(item.idInput);
    });
    onChange(checkboxValue);
  };

  return (
    <>
      <CheckboxGroupContainer>
        <Checkbox.Group
          options={options}
          onChange={onChangeValue}
          defaultValue={defaultValue}
          disabled={disabledField}
        />
      </CheckboxGroupContainer>
    </>
  );
};

CheckboxGroupComponent.propTypes = {
  field: PropTypes.shape({
    idInput: PropTypes.string,
    label: PropTypes.string,
    obligatory: PropTypes.bool,
    list: PropTypes.array,
  }),
  value: PropTypes.object,
  onChange: PropTypes.func,
  disabledField: PropTypes.bool,
};

export default CheckboxGroupComponent;
